import { IActivity } from '@sdk/contracts';
import { dateProvider } from '@utils';
import { Button, Flex } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  TableContentWrapper,
  TableContentItem,
  TableContentItemValue,
  TableContentItemTitle,
  TableTitleWrapper
} from './ActivitySummaryTable.styles';

import { UnsyncActivityConfirmation } from '@/components/Activities/UnsyncActivityConfirmation';
import { Icon } from '@/components/Icon';

type Props = {
  activity: IActivity;
};

export const ActivitySummaryTable: React.FC<Props> = ({ activity }) => {
  const { t } = useTranslation('CourseTranslations');
  const [isUnsyncActivityModalOpen, setIsUnsyncActivityModalOpen] = useState(false);

  return (
    <>
      <UnsyncActivityConfirmation
        activity={activity}
        isModalOpen={isUnsyncActivityModalOpen}
        setIsModalOpen={setIsUnsyncActivityModalOpen}
      />

      <Flex vertical gap={32}>
        <Flex vertical gap={8}>
          <TableTitleWrapper>{t('SELECTED_ACTIVITY_INFO')}</TableTitleWrapper>

          <TableContentWrapper>
            <TableContentItem>
              <TableContentItemTitle>{t('ACTIVITY')}</TableContentItemTitle>
              <TableContentItemValue>{activity.name}</TableContentItemValue>
            </TableContentItem>

            <TableContentItem>
              <TableContentItemTitle>{t('LAST_UPDATE')}</TableContentItemTitle>
              <TableContentItemValue>
                {dateProvider.format(activity.updatedAt, 'dd/MM/yyyy')}
              </TableContentItemValue>
            </TableContentItem>

            <TableContentItem>
              <TableContentItemTitle>{t('ACTION')}</TableContentItemTitle>
              <TableContentItemValue>
                <Button
                  type="text"
                  icon={<Icon i="IbmDataReplication" size={16} />}
                  onClick={() => setIsUnsyncActivityModalOpen(true)}
                  danger
                  size="small"
                  style={{ padding: 0 }}>
                  {t('UNSYNC_ACTIVITY')}
                </Button>
              </TableContentItemValue>
            </TableContentItem>
          </TableContentWrapper>
        </Flex>

        <Flex vertical gap={8} style={{ paddingBottom: 24 }}>
          <TableTitleWrapper>{t('SYNCED_WITH')}</TableTitleWrapper>
          <TableContentWrapper>
            <TableContentItem>
              <TableContentItemTitle>{t('COURSE')}</TableContentItemTitle>
              <TableContentItemValue>{activity.parentCourse?.name}</TableContentItemValue>
            </TableContentItem>

            <TableContentItem>
              <TableContentItemTitle>{t('SECTION')}</TableContentItemTitle>
              <TableContentItemValue>{activity.parentSection?.name}</TableContentItemValue>
            </TableContentItem>

            <TableContentItem>
              <TableContentItemTitle>{t('ACTIVITY')}</TableContentItemTitle>
              <TableContentItemValue>{activity.parentActivity?.name}</TableContentItemValue>
            </TableContentItem>
          </TableContentWrapper>
        </Flex>
      </Flex>
    </>
  );
};
